import axios from "axios";

const setAuthToken = (token) =>{
    if (token){
        axios.defaults.headers.common['x-auth-token'] = token;
    }
    else{
        delete axios.defaults.headers.common['x-auth-token'];
    }

    const guestToken = localStorage.getItem('guestToken');
    if (guestToken){
        axios.defaults.headers.common['x-guest-token'] = guestToken;
    }
    else{
        delete axios.defaults.headers.common['x-guest-token'];
    }
}

export default setAuthToken;

